export default "__VITE_ASSET__BGocTc3n__"